var _defs, _circle, _circle2, _polyline, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApireponse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke:#5580c0;stroke-linecap:round;stroke-width:8px;}.cls-1{stroke-miterlimit:10;}.cls-2{stroke-linejoin:round;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 27.65,
    cy: 27.68,
    r: 11.82
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 121.65,
    cy: 121.68,
    r: 11.82
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "71.6 111.42 83.42 123.24 70.95 133.78"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63.12,27.68H98.59a23.65,23.65,0,0,1,23.64,23.65h0A23.64,23.64,0,0,1,98.59,75H51.3A23.65,23.65,0,0,0,27.65,98.62h0A23.65,23.65,0,0,0,51.3,122.26H74.94"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApireponse);
export default __webpack_public_path__ + "static/media/apireponse.3a2785ea.svg";
export { ForwardRef as ReactComponent };